const PropTypes = require('prop-types');
const React = require('react');

const HoldersDataList = require('./HoldersDataList');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { formatText, FormattedText } = require('core/i18n').i18n;
const formHelper = require('../../utilities/formHelper');

class Holders extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            if (this.props.values[0]) {
                initialState = {
                    holdersSelected: this.props.values[0],
                    component_id: 'holders'
                }
            } else {
                initialState = {
                    holdersSelected: false,
                    component_id: 'holders'
                };
                this.props.dataReceiver([false, []]);
            }
        } else {
            initialState = {
                holdersSelected: false,
                component_id: 'holders'
            };
            this.props.dataReceiver([false, []]);
        }

        this.state = initialState;
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.onDataReceiver = this.onDataReceiver.bind(this);
        this.buildRadioGroup = this.buildRadioGroup.bind(this);
    }

    componentWillMount() {
        const { clearInterveners, addSimpleIntervener,immProfileFields } = this.props;
        // Reset the card details values
        clearInterveners();
        if (immProfileFields.get('nombreCliente')) {
            addSimpleIntervener(immProfileFields.get('nombreCliente') + immProfileFields.getIn(['apellidoUno','apellido']) + immProfileFields.getIn(['apellidoDos','apellido']), '01', immProfileFields.getIn(['documentoIdentificacion','codigodocumpersonacorp']));
        }
    }

    componentWillUnmount() {
        const { interveners, addSimpleIntervener } = this.props;
        let value = interveners.get(0);
        if (value) {
            interveners.get(1).map((holder) => {
                let names = holder.get('firstName') + ' ' + holder.get('lastName') + ' ' + holder.get('secondlastName');
                let type = holder.get('accountRelation');
                addSimpleIntervener(names.toUpperCase(), type, holder.get('identificationValue'));
            });
        }
    }

    onDataReceiver(data) {
        data = [this.state.holdersSelected, data];
        this.props.dataReceiver(data);
    }

    buildRadioButton(radioButton) {
        return (
            <RadioButton
                label={radioButton.label}
                value={radioButton.value}
                key={radioButton.label}
                className="block-step__radio"
            />
        );
    }

    buildRadioGroup(radioOptions) {
        const errorMessage = formatText('contractsView-radioButtonsRequiredError');
        const { errorsState } = this.props;
        const error = (typeof errorsState[0] !== 'undefined') ? errorsState[0] : false;

        return (
            <RadioButtonGroup
                name="holders"
                idPrefix="holdersSelected"
                key={"holdersSelected"}
                selectedValue={this.state.holdersSelected}
                className="block-step__radio-group"
                onChange={this.handleRadioButtonChange}
                errorMessage={errorMessage}
                errorState={error}
            >
                {radioOptions}
            </RadioButtonGroup>
        );
    }

    buildPersonalInfoDisclaimer() {
        const {
            immPersonalInfoDisclaimerTexts,
            immPersonalInfoDisclaimerComponent
        } = this.props;
        let personalInfoDisclaimer;
        
        if (this.state.holdersSelected &&
            immPersonalInfoDisclaimerTexts !== undefined &&
            immPersonalInfoDisclaimerComponent !== undefined) {

            const label = <FormattedText value={immPersonalInfoDisclaimerTexts.get('label')} />;
            const errorMessage = formatText(immPersonalInfoDisclaimerTexts.get('errorMessage'));
            const errorState = immPersonalInfoDisclaimerComponent.get('isErrorVisible') && !immPersonalInfoDisclaimerComponent.get('value');

            personalInfoDisclaimer = (
                <OKCheckbox
                    errorState={errorState}
                    errorMessage={errorMessage}
                    extraClass="holders-form__personal-info-disclaimer-checkbox"
                    idName="holder_personal_info_disclaimer"
                    label={label}
                    onChange={this.props.onPersonalInfoDisclaimerCheck}
                    value={immPersonalInfoDisclaimerComponent.get('value')}
                />
            );
        }

        return personalInfoDisclaimer;
    }

    handleRadioButtonChange(event) {
        event = formHelper.stringToBoolean(event);
        this.setState({holdersSelected: event});
        this.props.dataReceiver([event, []]);
    }

    showHolderForm() {
        const {
            errorsState,
            holderDescription,
            identificationTypeSource,
            regexInputFullName,
            relationTypeSource,
            values
        } = this.props;
        const description = holderDescription ? <FormattedText value={holderDescription} /> : null;
        if (this.state.holdersSelected) {
            return (
                <div>
                    {description}
                    <HoldersDataList
                        regexInputFullName={regexInputFullName}
                        relationTypeSource={relationTypeSource}
                        identificationTypeSource={identificationTypeSource}
                        dataReceiver={this.onDataReceiver}
                        values={values !== null ? values[1] : []}
                        errorsState={errorsState}
                    />
                </div>
            );

        }
        else {
            return null;
        }
    }

    render() {
        let radioOptions = [], wrapperStyle = this.state.holdersSelected ? 'holders-form__all' : '';
        this.props.radioOptions.forEach(option => {
            radioOptions.push(this.buildRadioButton(option));
        });
        switch (this.props.type) {
            case 'single':
                const personalInfoDisclaimer = this.buildPersonalInfoDisclaimer();
                return (
                    <div className="holders-form">
                        <FormattedText value="contractsView-checkingAccountHoldersFirstRadioGroupTitle" className="holders-form__slider-text"/>
                        {this.buildRadioGroup(radioOptions)}
                        {personalInfoDisclaimer}
                        <div className={wrapperStyle}>
                            {this.showHolderForm()}
                        </div>
                    </div>);
            case 'form':
                return (
                    <div className="holders-form ">
                        <FormattedText value="contractsView-checkingAccountHoldersSecondRadioGroupTitle" className="holders-form__slider-text"/>
                        <div  className={wrapperStyle}>
                            {this.buildRadioGroup(radioOptions)}
                            <div>
                                {this.showHolderForm()}
                            </div>
                        </div>
                    </div>
                )
        }
    }
}

Holders.defaultProps = {
    type: 'single'
};

Holders.propTypes = {
    radioOptions: PropTypes.array,
    taxCountryOptions: PropTypes.array,
    relationTypeSource: PropTypes.array,
    identificationTypeSource: PropTypes.array,
    type: PropTypes.string,
    dataReceiver: PropTypes.func,
    values: PropTypes.any.isRequired,
    errorsState: PropTypes.any.isRequired,
    interveners: PropTypes.any,
    addSimpleIntervener: PropTypes.func,
    clearInterveners: PropTypes.func,
    immProfileFields: PropTypes.object,
    regexInputFullName: PropTypes.any,
    holderDescription: PropTypes.string,
    immPersonalInfoDisclaimerComponent: PropTypes.object,
    immPersonalInfoDisclaimerTexts: PropTypes.object,
    onPersonalInfoDisclaimerCheck: PropTypes.func
};

module.exports = Holders;